import {FC, useEffect, useState} from 'react';

export const NoSSR: FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted ? <>{children}</> : null;
};
